import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const clientLinks: Record<string, string> = {
  client1: 'https://store.elorayem.com',

};

const exts = ['webp', 'png', 'jpg', 'jpeg'];

const clientImages: { key: string; alts: string[]; srcs: string[] }[] = Object.keys(clientLinks).map((key, idx) => ({
  key,
  alts: [
    `Client ${idx + 1}`,
    key.replace(/^client/, 'Client ')
  ],
  srcs: exts.map(ext => `/images/${key}.${ext}`)
}));

function LogoImage({ srcs, alts }: { srcs: string[]; alts: string[] }) {
  const [idx, setIdx] = useState(0);
  if (idx >= srcs.length) return null;
  return (
    <img
      src={srcs[idx]}
      alt={alts[0]}
      className="h-32 w-auto object-contain grayscale hover:grayscale-0 transition-all duration-300 opacity-70 hover:opacity-100"
      onError={() => setIdx(idx + 1)}
      style={{ display: 'block' }}
    />
  );
}

export function LogoCloud() {
  const { t } = useTranslation();

  return (
    <section className="py-12 bg-slate-50 border-y border-slate-100">
      <div className="mx-auto max-w-7xl px-4">
        <p className="text-center text-3xl font-bold text-slate-800 mb-12">
          {t('logo_cloud.title', 'Trusted by leading restaurants')}
        </p>
        <div className="relative w-full overflow-hidden" dir="ltr">
          <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-slate-50 to-transparent z-10"></div>
          <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-slate-50 to-transparent z-10"></div>
          
          <div
            className="flex animate-scroll-logos whitespace-nowrap items-center"
            style={{ width: 'max-content' }}
          >
            {[...clientImages, ...clientImages, ...clientImages].map((logo, idx) => (
              <a
                key={logo.key + '-' + idx}
                href={clientLinks[logo.key]}
                target="_blank"
                rel="noopener noreferrer"
                className="mx-12 md:mx-20 inline-block"
              >
                <LogoImage srcs={logo.srcs} alts={logo.alts} />
              </a>
            ))}
          </div>
        </div>
      </div>
      <style>{`
        @keyframes scroll-logos {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.33%); }
        }
        .animate-scroll-logos {
          animation: scroll-logos 15s linear infinite;
        }
        .animate-scroll-logos:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
}
